import { useCallback } from "react";
import { FilterChip } from "../FilterChip";
import { ConditionToggleFilter } from "./ConditionToggleFilter";
import { FilterMode } from "./types";
import { FILTER_MODE } from "./constants";

interface ConditionToggleFilterChipProps {
  condition: FilterMode | undefined;
  handleConditionChange: (condition: FilterMode) => void;
  id?: string;
}

export const ConditionToggleFilterChip = ({
  condition,
  handleConditionChange,
  id = "condition-toggle",
}: ConditionToggleFilterChipProps) => {
  const renderChipLabel = useCallback((condition: string | undefined) => {
    if (!condition) return "Select Any/All";
    return Object.keys(FILTER_MODE).find(
      (key) => FILTER_MODE[key] === condition
    );
  }, []);

  return (
    <FilterChip
      label="Any/All"
      id={id}
      getSelectedCount={() => 0}
      renderLabel={() => renderChipLabel(condition)}
      popoverOptions={{ disableActionButtons: true }}
    >
      <ConditionToggleFilter
        id={`${id}-toggle`}
        value={condition}
        onChange={handleConditionChange}
      />
    </FilterChip>
  );
};
